module.exports = __webpack_public_path__ + "static/media/portfolio-03 copy.daa83bcb.jpg";